module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-jack.4d8c7968.svg";